import { FormLayout } from "@careinfo/layout";
import { useForm } from "react-hook-form";
import ShipviaForm from "./ShipviaForm";

const EditShipvia = (props) => {
  const { handleEdit, isLoading, data } = props;
  const {
    handleSubmit,
    register,
    formState: { errors },
    setError,
    control,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        ...data,
      };
    },
  });

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <ShipviaForm register={register} errors={errors} control={control} />
    </FormLayout>
  );
};

export default EditShipvia;
